/**
 * Schedule extractors.
 *
 * Projects one Cypher row from `PLANT_SCHEDULE_GATEWAYS_CYPHER` into a
 * typed {@link PlantScheduleGateway}. The Compute node's
 * `web_dev_project` is captured as `project_name` so the per-gateway
 * `getActiveSchedules` poller can scope its live-tag read to the right
 * Ignition project without an extra round-trip.
 *
 * Pure functions, no RTK / no Ignition driver — trivially unit-testable.
 */

import { extractNode, toIntCount } from '../graph-row'
import { extractPlantMeta } from './provenance'
import type { PlantComputeHost, PlantScheduleGateway } from '../types'

/** Project one Cypher row from `PLANT_SCHEDULE_GATEWAYS_CYPHER`. */
export function mapPlantScheduleGatewayRow(
  row: Record<string, unknown>
): PlantScheduleGateway | null {
  const node = extractNode<PlantComputeHost>(row['c'])
  if (!node) return null
  const webDevProject = (node as unknown as Record<string, unknown>)['web_dev_project']
  return {
    id: node.id,
    name: node.name,
    ...extractPlantMeta(node as unknown as Record<string, unknown>),
    url: typeof node.url === 'string' ? node.url : '',
    project_name:
      typeof webDevProject === 'string' && webDevProject.length > 0 ? webDevProject : null,
    scheduleProfileCount: toIntCount(row['scheduleProfileCount']),
    holidayCount: toIntCount(row['holidayCount'])
  }
}
